import React from 'react';
import request from '../../request';
import { Link } from 'react-router-dom';
import StudiesContainer from '../shared/studies';

export default class Pending extends React.Component {
  constructor() {
    super();
    this.state = { checked: [] };
  }

  render() {
    let { checked, load } = this.state;
    let { studies, loading } = this.props;
    return (
      <div>
        <h5 className="heading lmtd">Pending</h5>
        <p className="all">
          <button
            className="control_button"
            type="submit"
            name="claim"
            value="claim"
            onClick={async () => {
              this.setState({ load: true });
              await request({
                url: `studies/claim`,
                method: 'POST',
                body: {
                  claim: checked,
                },
              });
              window.location.reload();
            }}
          >
            Claim Checked
          </button>
          {studies && studies.pending && studies.pending.length === 10
            ? <em>|</em>
            : null}
          {studies && studies.pending && studies.pending.length === 10
            ? <Link to="/types/pending">View All</Link>
            : null}
        </p>
        <StudiesContainer
          studies={studies ? studies.pending : null}
          empty="There are no pending studies"
          loading={loading || load}
          lastColumn="Added"
          checked={checked}
          onChecked={checked => this.setState({ checked })}
        />
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/dashboard/pending.js